import { useHistory } from 'react-router-dom';

function useGoBackToCase() {
  const history = useHistory();
  const goBack = (caseId: string) => {
    if ((history.location.state as any)?.['from'] === 'caseInfo') {
      history.goBack();
    } else {
      history.push(`/cases/${caseId}`);
    }
  };

  return goBack;
}

export default useGoBackToCase;
